export const accountingPeriodsEn = {
  "periodQuery.scope": "Read dates",
  "periodQuery.selected": "Selected period",
  "periodQuery.all": "All periods",
  "periodQuery.custom": "Custom date range",
  "periodQuery.multiple": "Selected periods",
  "periodQuery.readOnlyFilter": "Filters do not move transactions between periods.",
  "periodQuery.invoiceBasis": "Invoice date basis",
  "periodQuery.completeRange": "Choose both dates for a financial report.",
  "periodQuery.contiguousRange": "Choose contiguous periods to calculate balances.",
  "periodQuery.aggregateRange": "This range includes part of an aggregate source. Choose its full date range to calculate balances.",
  "periodQuery.inUse": "This period has accounting records or is locked; its dates cannot be changed.",
  "periodQuery.openOwner": "Open period: {{name}}",
} as const

export const accountingPeriodsRu: Record<keyof typeof accountingPeriodsEn, string> = {
  "periodQuery.scope": "Период просмотра",
  "periodQuery.selected": "Выбранный период",
  "periodQuery.all": "Все периоды",
  "periodQuery.custom": "Произвольный диапазон дат",
  "periodQuery.multiple": "Выбранные периоды",
  "periodQuery.readOnlyFilter": "Фильтры не перемещают операции между периодами.",
  "periodQuery.invoiceBasis": "Дата для отбора счетов",
  "periodQuery.completeRange": "Для финансового отчёта укажите начальную и конечную даты.",
  "periodQuery.contiguousRange": "Для расчёта остатков выберите периоды, следующие друг за другом без промежутков.",
  "periodQuery.aggregateRange": "Выбранный диапазон охватывает только часть исходных сводных данных. Для расчёта остатков выберите весь период этих данных.",
  "periodQuery.inUse": "В периоде уже есть бухгалтерские данные или он заблокирован; изменить его даты нельзя.",
  "periodQuery.openOwner": "Открыть период: {{name}}",
}

export const accountingPeriodsEt: Record<keyof typeof accountingPeriodsEn, string> = {
  "periodQuery.scope": "Kuvatav ajavahemik",
  "periodQuery.selected": "Valitud periood",
  "periodQuery.all": "Kõik perioodid",
  "periodQuery.custom": "Kohandatud ajavahemik",
  "periodQuery.multiple": "Valitud perioodid",
  "periodQuery.readOnlyFilter": "Filtrid ei liiguta tehinguid ühest perioodist teise.",
  "periodQuery.invoiceBasis": "Arvete filtreerimise kuupäev",
  "periodQuery.completeRange": "Finantsaruande jaoks vali algus- ja lõppkuupäev.",
  "periodQuery.contiguousRange": "Saldode arvutamiseks vali järjestikused perioodid, mille vahele ei jää lünki.",
  "periodQuery.aggregateRange": "Valitud ajavahemik hõlmab ainult osa lähteandmete koondnäitajatest. Saldode arvutamiseks vali nende andmete kogu periood.",
  "periodQuery.inUse": "Perioodis on juba raamatupidamiskandeid või see on lukustatud; kuupäevi ei saa muuta.",
  "periodQuery.openOwner": "Ava periood: {{name}}",
}
